export const URLS = {
    login: '/api/auth/token',
    refreshToken: '/authenticated/refresh-token',
    userContext: '/authenticated/user-context',
    logout: '/authenticated/user/logout',
    forgot: '/api/users/send-code',
    resend: '/api/users/resend-code',
    reset: '/api/users/password',
    verifyCode: '/api/users/validate-code',
    resendCode: '/api/users/resend-code',

    resetPassword: '/authenticated/users/current-user/password',
    tarnslation: (language: string) => `/api/admin-translations/${language}`,

    download_import_address_template: '/authenticated/import-countries/template',
    import_address: '/authenticated/import-countries',

    import_addOn: '/authenticated/import-add-ons',
    import_addOn_validate: '/authenticated/import-add-ons/validate',
    download_import_addons_template: '/authenticated/import-add-ons/template',
    import_eventTypes: '/authenticated/sa/property-onboarding/import-event-types',
    import_eventTypes_validate: '/authenticated/sa/property-onboarding/import-event-types/validate',
    download_import_eventTypes_template: '/authenticated/sa/property-onboarding/import-event-types/template',
    import_venues: '/authenticated/sa/property-onboarding/import-venues',
    import_venues_validate: '/authenticated/sa/property-onboarding/import-venues/validate',
    download_import_venues_template: '/authenticated/sa/property-onboarding/import-venues/template',
    import_pricePackages: '/authenticated/sa/property-onboarding/import-price-packages',
    import_pricePackages_validate: '/authenticated/sa/property-onboarding/import-price-packages/validate',
    download_import_pricePackages_template: '/authenticated/sa/property-onboarding/import-price-packages/template',
    import_layouts: '/authenticated/sa/property-onboarding/import-layouts',
    import_layouts_validate: '/authenticated/sa/property-onboarding/import-layouts/validate',
    download_import_layouts_template: '/authenticated/sa/property-onboarding/import-layouts/template',
    addBookingLineItem: (id: any) => `/authenticated/bookings/${id}/line-item`,
    finalizeActualization: (bookingLineItemId: number | string) =>
        `/authenticated/booking-items/${bookingLineItemId}/finalize-actualization`,
    reopenActualization: (bookingLineItemId: number | string) =>
        `/authenticated/booking-items/${bookingLineItemId}/reopen-actualization`,
    // profile
    language: '/api/languages',
    countries: '/authenticated/countries',
    states: (id: number) => `/authenticated/countries/${id}/states`,
    cities: (id: number) => `/authenticated/states/${id}/cities`,
    userProfile: '/authenticated/user/profile',
    superAdminBookingByOrderRef: (orderReferenceNo: string) =>
        `/authenticated/sa/bookings/${encodeURIComponent(orderReferenceNo)}`,
    superAdminBookingGuestDetails: (orderReferenceNo: string) =>
        `/authenticated/sa/bookings/${encodeURIComponent(orderReferenceNo)}/guest-details`,
    superAdminBookingBookingDetails: (orderReferenceNo: string) =>
        `/authenticated/sa/bookings/${encodeURIComponent(orderReferenceNo)}/booking-details`,
    superAdminBookingPaymentConfig: (orderReferenceNo: string) =>
        `/authenticated/sa/bookings/${encodeURIComponent(orderReferenceNo)}/payment-config`,
    superAdminBookingLineItem: (lineItemId: number | string) =>
        `/authenticated/sa/bookings/line-items/${encodeURIComponent(String(lineItemId))}`,
    superAdminBookingLineItemRestore: (lineItemId: number | string) =>
        `/authenticated/sa/bookings/line-items/${encodeURIComponent(String(lineItemId))}/restore`,
    superAdminBookingLineItemFormOptions: (lineItemId: number | string, venueId?: number | string) => {
        const base = `/authenticated/sa/bookings/line-items/${encodeURIComponent(String(lineItemId))}/form-options`;
        if (venueId != null && String(venueId).trim() !== '') {
            return `${base}?venueId=${encodeURIComponent(String(venueId))}`;
        }
        return base;
    },
    propertyOnboardingStatus: '/authenticated/sa/property-onboarding/status',
    propertyReadinessDashboard: '/authenticated/sa/property-readiness/dashboard',
    propertyReadinessCreateMissingConfigs: '/authenticated/sa/property-readiness/create-missing-configs',
    getCheckInStatus: '/authenticated/users-session/status',
    toggleSessions: '/authenticated/users-sessions/toggle',
    getAllSessionsForLoggedInUser: '/authenticated/users-sessions/page',
    getUserSessions: (userId: number) => `/authenticated/users/${userId}/sessions`,
    updateHighDemandDate: (id: string) => `/authenticated/organizations/${id}/high-demand-dates`,
    // role
    role: '/authenticated/user/roles',
    rolePage: '/authenticated/roles/page',
    addRole: '/authenticated/roles',
    editRole: (id: string | undefined) => `/authenticated/roles/${id}`,
    deleteRole: (id: string) => `/authenticated/roles/${id}`,
    updatePriviliges: (id: string) => `/authenticated/roles/${id}/privileges`,

    // user management
    users: (flag: boolean) => `/authenticated/users/page?isCustomer=${flag}`,
    addUser: '/authenticated/user',
    getUserById: (id: number | string) => `/authenticated/user/${id}`,
    editUserById: (id: string) => `/authenticated/user/${id}`,
    deleteUserById: (id: string) => `/authenticated/user/${id}`,
    resetUser: (id: number) => `/authenticated/user/${id}/reset-password`,
    toggleUser: (id: number) => `/authenticated/user/${id}/toggle`,
    uploadUserDocuments: (id: number) => `/authenticated/bookings/${id}/documents`,
    getKycDocuments: (customerId: number) => `/authenticated/bookings/${customerId}/documents`,
    updateKycDocument: (customerId: number, id: number) => `/authenticated/bookings/${customerId}/documents/${id}`,
    deleteKycDocument: (customerId: number, id: number) => `/authenticated/bookings/${customerId}/documents/${id}`,

    // agent
    agents: '/authenticated/agents/page',
    addAgent: '/authenticated/agent',
    editAgent: (id: string) => `/authenticated/agent/${id}`,
    deleteAgent: (id: string) => `/authenticated/agent/${id}`,
    toggleAgent: (id: number) => `/authenticated/agent/${id}/toggle`,

    // budget
    budgets: '/authenticated/budgets/page',
    addBudget: '/authenticated/budget',
    editBudget: (id: string) => `/authenticated/budget/${id}`,
    budgetManagers: '/authenticated/budget-managers',
    deleteBudget: (id: string) => `/authenticated/budget/${id}`,
    sourcesList: '/authenticated/sources',

    // venueType
    venueType: '/authenticated/venue-types/page',
    venueTypes: '/authenticated/currentuser/organization/venue-types',
    get_edit_delete_VenueTypeById: (id: number) => `/authenticated/venue-type/${id}`,
    addVenuetype: '/authenticated/venue-type',

    // customer
    addCustomer: '/authenticated/user',
    editCustomer: (id: string) => `/authenticated/user/${id}`,
    deleteCustomer: (id: string) => `/authenticated/user/${id}`,
    searchCustomersWithMappings: (query: string) => `/authenticated/customers/search?query=${query ?? ''}`,
    addCustomerCompanyBranchMapping: (id: number | string) => `/authenticated/customers/${id}/company-branch-mappings`,

    customerDetails: (id: any) => `/authenticated/booking-items/${id}/customer-details`,
    getMembershipDetails: (id: number | string) => `/authenticated/users/${id}/membership-details`,
    addMembershipDetails: (id: number | string) => `/authenticated/users/${id}/membership-details`,

    // rfq
    requestForQuotes: '/authenticated/rfqs/page',
    viewRfq: (id: number) => `/authenticated/rfqs/${id}`,
    addBeoAmendments: (id: number) => `/authenticated/booking-items/${id}/beo-amendments`,
    getEventAndVenuesRfq: '/authenticated/rfqs/master-data',
    getPricePackageRfq: `/authenticated/rfqs/venue-configs`,
    addRfq: 'authenticated/rfqs',
    deleteRfq: (id: number) => `/authenticated/rfqs/${id}`,

    location: '/authenticated/locations/page',
    get_edit_delete_locationById: (id: number) => `/authenticated/location/${id}`,
    addLocation: '/authenticated/location',

    addOns: '/authenticated/add-ons/page',
    get_edit_delete_addOnsById: (id: number) => `/authenticated/addOn/${id}`,
    add_addOns: '/authenticated/addOn',
    bulkUpdateAddOns: '/authenticated/add-ons/bulk',
    getOrganizationTaxCodes: '/authenticated/currentuser/organization/tax-codes',
    addon_image: (id: number) => `/authenticated/addOn/image/${id}`,

    eventType: '/authenticated/event-types/page',
    eventTypesDropdown: '/authenticated/event-types/dropdown',
    get_edit_delete_eventTypeById: (id: number) => `/authenticated/event-type/${id}`,
    addEventType: '/authenticated/event-type',

    roomType: '/authenticated/room-types/page',
    roomTypeDropdown: '/authenticated/room-types',
    get_edit_delete_roomTypeById: (id: number) => `/authenticated/room-type/${id}`,
    addRoomType: '/authenticated/room-type',

    templateSchedule: '/authenticated/template-schedules/page',
    get_edit_delete_templateScheduleById: (id: number) => `/authenticated/template-schedule/${id}`,

    taxCode: '/authenticated/tax-codes/page',
    getTaxCodesById: (id: number) => `/authenticated/tax-code/${id}`,
    edit_taxCode: (id: number) => `/authenticated/tax-codes/${id}`,
    addTaxCode: '/authenticated/tax-codes',

    taxGroup: '/authenticated/tax-groups/page',
    getTaxGroupById: (id: number) => `/authenticated/tax-group/${id}`,
    editTaxGroup: (id: number) => `/authenticated/tax-groups/${id}`,
    addTaxGroup: '/authenticated/tax-groups',
    taxGroupTaxCodes: '/authenticated/tax-group/tax-codes',
    taxGroupDropdown: '/authenticated/tax-groups/dropdown',

    surchargeList: '/authenticated/tax-code/surcharges',
    surcharge: '/authenticated/surcharges/page',
    get_edit_delete_surcharge: (id: number) => `/authenticated/surcharge/${id}`,
    addsurcharge: '/authenticated/surcharge',

    layouts: '/api/layouts',
    layout: '/authenticated/layouts/page',
    get_edit_delete_layoutById: (id: number) => `/authenticated/layout/${id}`,
    addLayout: '/authenticated/layout',
    layoutImage: (id: number) => `/authenticated/layout/image/${id}`,
    systemMessages: '/authenticated/system-messages/page',
    get_edit_systemMessagesId: (id: number) => `/authenticated/system-message/${id}`,
    bookingMessages: '/authenticated/booking-messages/page',
    get_edit_bookingMessagesId: (id: number) => `/authenticated/booking-message/${id}`,
    pricePackage: '/authenticated/price-packages/page',
    get_edit_delete_pricePackageById: (id: number) => `/authenticated/price-package/${id}`,
    updatePricePackageSortOrder: (id: number) => `/authenticated/price-package/${id}/sort-order`,
    addPricePackage: '/authenticated/price-package',
    mailTemplate: '/authenticated/mail-templates/page',
    get_edit_delete_mailTemplateById: (id: number) => `/authenticated/mail-template/${id}`,
    parentOrganization: '/authenticated/parent-organizations/page',
    organization: '/authenticated/organizations/page',
    addOrganization: '/authenticated/organizations',
    cloneOrganization: (id: number) => `/authenticated/organizations/${id}/clone`,
    getOrgGeneralById: (id: number) => `/authenticated/organizations/${id}`,
    getOrgMediaInfoById: (id: number) => `/authenticated/organizations/${id}/media`,
    getOrgLocalizedInfoById: (id: number) => `/authenticated/organizations/${id}/localized-attributes`,

    organizationLocation: '/authenticated/organization/locations',
    organizationCurrency: '/authenticated/currency-locales',
    get_edit_parentOrganizationById: (id: number) => `/authenticated/parent-organization/${id}`,
    updateParentOrganizationMediaInfo: (id: number) => `/authenticated/parent-organization/${id}/media`,

    parentOrganizarion_master_data: '/authenticated/parent-organization/master-data',
    rooms: '/authenticated/rooms/page',
    getRoomsById: (id: number) => `/authenticated/room/${id}`,
    addRooms: '/authenticated/room',
    venue: '/authenticated/venues/page',
    getVenueRfq: '/authenticated/organization/venues',
    getRFQPointers: '/authenticated/rfq-pointers',
    getBookingStats: `/authenticated/bookings/stats`,

    get_edit_delete_VenueById: (id: number) => `/authenticated/currentuser/organization/venues/${id}`,
    venue_edit: (id: number) => `/authenticated/currentuser/organization/venues/${id}`,
    addVenue: '/authenticated/currentuser/organization/venues',
    get_edit_delete_VenueConfigurationById: (id: number) => `/authenticated/currentuser/organization/venue-configs/${id}`,
    venueConfiguration: '/authenticated/venue-configs/page',
    checkUnavailablityDate: (id: number) => `/authenticated/venues/${id}/unavailability-dates`,
    addVenueConfiguration: '/authenticated/currentuser/organization/venue-configs',
    bulkCreateVenueConfiguration: '/authenticated/currentuser/organization/venue-configs/bulk',
    venueConfigDefaults: '/authenticated/currentuser/organization/venue-configs/defaults',
    venueConfigDropdownData: '/authenticated/currentuser/organization/master-data',
    venueConfigsUpdateGeneral: (id: number) => `authenticated/currentuser/organization/venue-configs/${id}/general`,
    venueConfigsUpdatePayment: (id: number) => `authenticated/currentuser/organization/venue-configs/${id}/payment`,
    venueConfigsUpdateMapping: (id: number) => `authenticated/currentuser/organization/venue-configs/${id}/mapping`,
    venueConfigsUpdatePrice: (id: number) => `authenticated/currentuser/organization/venue-configs/${id}/price`,
    venueConfigCopy: (id: number) => `authenticated/currentuser/organization/venue-configs/${id}/copy`,
    venueConfigSyncToSegments: (id: number) =>
        `authenticated/currentuser/organization/venue-configs/${id}/sync-to-segments`,
    venueConfigsUpdateLocalizedAttributes: (id: number, lang: string) =>
        `authenticated/currentuser/organization/venue-configs/${id}/localized-attributes/${lang}`,
    uploadVenueImage: (id: any) => `authenticated/currentuser/organization/venues/${id}/media`,
    // Email Event Config
    emailEventConfigDropdowns: 'authenticated/email-event-configs/dropdowns',

    emailEventConfig: 'authenticated/email-event-configs/page',
    emailEventConfigAdd: 'authenticated/email-event-configs',
    emailEventConfigById: (id: number) => `authenticated/email-event-configs/${id}`,

    // Email Server Config (organization tab)
    orgMailConfig: (id: number) => `/authenticated/organizations/${id}/mail-config`,
    orgMailConfigTestEmail: (id: number) => `/authenticated/organizations/${id}/mail-config/test-email`,

    // Payment Config
    organizationDropdowns: '/authenticated/mapped-organizations',
    paymentProviderDropdowns: 'authenticated/payment-providers',
    paymentConfig: 'authenticated/payment-configs/page',
    addPaymentConfig: '/authenticated/payment-configs',
    paymentConfigById: (id: number) => `authenticated/payment-configs/${id}`,

    // bookings
    bookings: '/authenticated/v2/calendar/bookings/page',
    exportBookings: '/authenticated/compare-bookings',
    exportAlifRv: '/authenticated/alif-export/rv',
    exportAlifCl: '/authenticated/alif-export/cl',
    bookingFilterList: '/authenticated/bookings-list/page',
    bookingEventSourcePage: '/authenticated/bookings/event-source/page',
    updateBookingEventSource: '/authenticated/bookings/event-source',
    deletedBookings: '/authenticated/deleted-bookings/page',
    exportDeletedBookings: '/authenticated/deleted-bookings/export',

    assignBookings: '/authenticated/assign-bookings',
    venuesAvailability: 'authenticated/venues-availability',
    venues: '/authenticated/venues',
    getBookingLineItemById: (id: number) => `/authenticated/booking-items/${id}`,
    getBillingCostingSummary: (id: number | string) => `/authenticated/booking-items/${id}/billing-costing-summary`,
    bookingPreviewTemplateById: (id: number) => `/authenticated/booking-items/${id}/preview-contract`,
    bookingPreviewTemplateByIdForEditBooking: (id: number) => `/authenticated/booking-items/${id}/preview`,
    bookingPreviewTemplate: `/authenticated/bookings/preview-contract`,
    bookingPreviewTemplatePdf: `/authenticated/bookings/preview-contract-pdf`,
    bookingPreviewTemplatePdfById: (id: number) => `/authenticated/booking-items/${id}/preview-contract-pdf`,
    bookingPreviewTemplatePdfByIdForEditBooking: (id: number) => `/authenticated/booking-items/${id}/preview-pdf`,
    regularCustomer: (name: string) => `/authenticated/regular-customers?name=${name}`,
    // New booking
    getDataForNewBooking: 'authenticated/new-booking/master-data',
    sendNewBookingData: 'authenticated/new-booking',
    sendBookingEmailAttachment: (id: any) => `/authenticated/bookings/${id}/send-email`,
    getDropdownsForVenueConfig: (eventID: string, venueID: string, corporateBooking: string) =>
        `/authenticated/venues/${venueID}/events/${eventID}/dropdowns?isCorporate=${corporateBooking || false}`,
    corporateRates: '/authenticated/crm/corporate-rates/check',

    cloneBooking: (id: number) => `authenticated/bookings/${id}`,
    cloneBookingFromRfq: (id: number) => `authenticated/rfqs/${id}/convert`,
    calculateBill: 'authenticated/new-booking/costing',
    reports: `/admin/v1/reports`,
    consolidatedReports: `/admin/consolidated-reports`,
    consolidatedReportsRevenueOverview: `/admin/consolidated-reports/revenue-overview`,
    consolidatedReportsContributionTrends: `/admin/consolidated-reports/contribution-trends`,
    consolidatedReportsLeaderboardInsights: `/admin/consolidated-reports/leaderboard-insights`,
    exportReport: '/admin/bookings/export',
    exportAngDetailsReport: '/admin/ang-details/export',
    exportSettlementReport: '/authenticated/actualizations/export',
    exportBookingsOfDay: '/authenticated/bookings-of-day/export',
    exportCustomers: '/authenticated/customers/export',
    exportRfqs: '/authenticated/rfqs/export',
    setTheme: '/authenticated/themes',
    setCustomerTheme: '/authenticated/customer-themes',
    getTheme: '/api/organization/admin-theme',
    getParentOrgInitialData: '/api/parent-organizations/initial-data',
    getOrganizations: '/authenticated/sa/organizations',
    setOrganizations: '/authenticated/organization/switch',
    bookingStatus: (id: any) => `/authenticated/booking-items/${id}/update-status`,
    cancelBookingLineItem: (id: any) => `/authenticated/booking-items/${id}/cancel`,
    deleteBookingLineItem: (id: any) => `/authenticated/booking-items/${id}/delete`,
    processRefund: (id: any) => `/authenticated/bookings/${id}/refund`,
    addPaymentForBookedRooms: (id: any) => `/authenticated/bookings/${id}/payment`,
    addPaymentForLineItem: (id: any) => `/authenticated/booking-line-items/${id}/payment`,
    refundPaymentForBookedRooms: (id: any) => `/authenticated/bookings/${id}/refund`,
    refundPaymentForLineItem: (id: any) => `/authenticated/booking-line-items/${id}/refund`,
    deletePayment: (bookingId: any, paymentId: any) => `/authenticated/bookings/${bookingId}/payments/${paymentId}`,
    bookingLineItemHistoryPage: (id: any) => `/authenticated/booking-line-items/${id}/history/page`,

    dashboard_past_bookings: '/authenticated/dashboard/past-bookings',
    dashboard_past_bookings_details: '/authenticated/dashboard/past-bookings/details',
    dashboard_upcoming_bookings: '/authenticated/dashboard/upcoming-bookings',
    dashboard_upcoming_beos: '/authenticated/dashboard/upcoming-beos',
    dashboard_rfq_bookings: '/authenticated/dashboard/rfqs',
    dashboard_booking_requests: '/authenticated/dashboard/booking-requests',
    dashboard_birthdays_anniversaries: '/authenticated/dashboard/birthdays-anniversaries',
    dashboard_revenue_overview: '/authenticated/dashboard/revenue-overview',
    dashboard_chart_data: '/authenticated/dashboard/chart-data',
    dashboard_cancel_tantative_bookings: '/authenticated/tentative-bookings',
    dashboard_waitlisted_bookings: '/authenticated/waitlisted-bookings',
    dashboard_update_task: (id: number) => `/authenticated/dashboard/tasks/${id}`,
    dashboard_rfq_task: (id: number) => `/authenticated/rfqs/${id}/status`,
    RoomTypeList: '/authenticated/room/room-types',
    getAmount: (id: any, priceId: any) => `/authenticated/booking-items/${id}/price-packages/${priceId}`,
    getMasterDataForLineItem: (id: any) => `/authenticated/booking-items/${id}/master-data`,
    editBookings: (id: any) => `/authenticated/booking-items/${id}`,
    moveBookingLineItem: (id: number | string) => `/authenticated/booking-items/${id}/move-date`,
    bulkConvertToConfirmed: (bookingId: number | string) => `/authenticated/bookings/${bookingId}/bulk-confirm-line-items`,
    import_booking_template: '/authenticated/import-bookings/template',
    import_booking: '/authenticated/import-bookings',
    salesExecutivesDropdown: '/authenticated/sales-executives',

    orgMasterDataList: (id: number) => `/authenticated/organizations/${id}/master-data/page`,
    orgMasterDataById: (id: any) => `/authenticated/organizations/${id}/master-data`,
    orgMasterDataDropdowns: (id: number | string, isParent: boolean) =>
        `/authenticated/organizations/${id}/master-data/dropdowns?isParent=${isParent}`,

    changePassword: '/authenticated/users/current-user/password',

    mealPlansList: '/authenticated/meal-plans/page',
    mealPlansById: (id: number) => `/authenticated/meal-plans/${id}`,
    new_booking_mealPlansById: (id: number, isCompany = false) =>
        `authenticated/room-types/${id}/meal-plans?isCompany=${isCompany}`,
    addMealPlans: '/authenticated/meal-plans',
    getMealPlansDropdown: '/authenticated/meal-plans',
    address: '/authenticated/countries/page',
    country: '/authenticated/countries',
    state: (countryId: number) => `/authenticated/countries/${countryId}/states`,
    city: (stateId: number) => `/authenticated/states/${stateId}/cities`,
    get_put_delete_country: (id: number) => `/authenticated/countries/${id}`,
    get_put_delete_city: (id: number) => `/authenticated/cities/${id}`,
    get_put_delete_state: (id: number) => `/authenticated/states/${id}`,
    mealPlan: (id: number) => `/authenticated/room-types/${id}/meal-plans`,
    beoData: (id: any) => `/authenticated/booking-items/${id}/beo`,
    beoIncludeFlags: (id: any) => `/authenticated/booking-items/${id}/beo/include-flags`,
    beoDropdown: (id: any) => `/authenticated/booking-items/${id}/beo/dropdown`,
    previewBeo: (id: number) => `/authenticated/booking-items/${id}/preview-beo`,
    downloadBEOPdf: (id: any) => `/authenticated/booking-items/${id}/download-beo`,
    sendBEOEmail: (id: any) => `/authenticated/booking-items/${id}/send-beo`,
    sendBEOEmailToAdmin: (id: any) => `/authenticated/booking-items/${id}/send-beo/admins`,

    getEventTypeList: 'api/event-types',
    getLocationList: '/authenticated/mapped-locations',
    getSearchedOrganisations: 'authenticated/search-organizations',
    getAvailableVenues: (id: any) => `authenticated/organizations/${id}/available-venues`,
    submitRfq: '/api/request-for-quote',
    getPricePackgeDesc: (id: any) => `/api/price-packages/${id}`,

    leadDropdown: '/authenticated/leads/dropdowns',
    leadCitiesDropdown: (id: any) => `authenticated/countries/${id}/cities`,

    followUpDropdown: 'authenticated/follow-ups/dropdowns',

    taskListPage: '/authenticated/tasks/page',
    getReportingUsers: '/authenticated/reporting-users',
    assignTasks: (id: number, assigneeId: number) => `/authenticated/tasks/${id}?assignee=${assigneeId}`,

    completeTask: (id: any) => `/authenticated/tasks/${id}/complete`,

    // ---Sales Company Master---
    addCompany: '/authenticated/crm/companies',
    getCompanyById: (id: number) => `/authenticated/crm/companies/${id}`,
    getCompanyLedger: (id: number) => `/authenticated/crm/companies/${id}/ledger`,
    getBranchLedger: (id: number, branchId: number) => `/authenticated/crm/companies/${id}/branches/${branchId}/ledger`,
    getCompanyProfileById: (id: number) => `/authenticated/crm/companies/${id}/profile`,
    validateCompany: (name: string) => `/authenticated/crm/companies/validate?name=${name}`,
    getCompaniesPage: '/authenticated/crm/companies/page',
    searchCompanies: (name: string) => `/authenticated/crm/companies/search?name=${name ?? ''}`,
    getCompanyFilters: '/authenticated/crm/companies/filters',
    importCompanies: '/authenticated/crm/companies/import',
    downloadCompaniesTemplate: '/authenticated/crm/companies/import/template',
    // ---Sales Company Branches import---
    importCompanyBranches: (id: number) => `/authenticated/crm/companies/${id}/branches/import`,
    downloadCompanyBranchesTemplate: '/authenticated/crm/companies/branches/import/template',
    getCompanyDropdown: `/authenticated/companies/dropdown`,
    getCompanyDropdownBooking: `/authenticated/sales-accounts/dropdown`,
    getCompanyBranchesDropdown: (id: any) => `/authenticated/companies/${id}/branches/dropdown`,

    // ---Sales Company Branches---
    getBranchById: (id: number, branchId: number) => `/authenticated/crm/companies/${id}/branches/${branchId}`,
    getBranchDetailsById: (id: number, branchId: number) =>
        `/authenticated/crm/companies/${id}/branches/${branchId}/address`,
    getOrAddBranchContact: (id: number, branchId: number) =>
        `/authenticated/crm/companies/${id}/branches/${branchId}/contacts`,
    companyBranchesPage: (id: number) => `/authenticated/crm/companies/${id}/branches/page`,
    getCorporateRatesDropdown: (id: number) => `/authenticated/crm/companies/${id}/corporate-rates`,
    previewCorporateRates: (companyId: number, rateId: number) =>
        `/authenticated/crm/companies/${companyId}/corporate-rates/${rateId}/preview`,
    sendCorporateRatesEmail: (companyId: number, rateId: number) =>
        `/authenticated/crm/companies/${companyId}/corporate-rates/${rateId}/send`,

    uploadCorporateRateContract: (companyId: number, rateId: number) =>
        `/authenticated/crm/companies/${companyId}/corporate-rates/${rateId}/contract`,

    // ---Sales Company Branch Customers import---
    importCompanyBranchCustomers: (companyId: number, branchId: number) =>
        `/authenticated/companies/${companyId}/branches/${branchId}/customers/import`,
    downloadCompanyBranchCustomersTemplate: (companyId: number, branchId: number) =>
        `/authenticated/companies/${companyId}/branches/${branchId}/customers/import/template`,

    // ---Sales Calls---
    addSalesCall: '/authenticated/crm/sales-call',
    fetchSalesCallById: (id: any) => `/authenticated/crm/sales-call/${id}`,
    salesCallPage: (tab: boolean) => `/authenticated/crm/sales-call/page?showTeamCalls=${tab}`,
    addSalesCallFollowUps: (id: number) => `/authenticated/crm/sales-call/${id}/follow-ups`,
    exportSalesCalls: '/authenticated/crm/sales-call/export',

    // ---Sales Reports---
    getSalesOverview: `/authenticated/crm/reports/overview`,
    getDailySalesReport: (id: number) => `/authenticated/crm/reports/dsr/${id}`,
    getDateWiseSummary: (userId: string | undefined, date: { startDate: string; endDate: string }) =>
        `/authenticated/crm/reports/activity-summary/${userId}?startDate=${date.startDate}&endDate=${date.endDate}`,
    getExecutivePortfolio: (userId: string | undefined) => `/authenticated/crm/reports/executive-portfolio/${userId}`,
    getExecutivePortfolioSummary: (userId: string | undefined, period: string | number) =>
        `/authenticated/crm/reports/executive-portfolio-summary/${userId}?period=${period}`,
    getCompanyPortfolio: (category: string | undefined) => `/authenticated/crm/reports/company-portfolio/${category}`,
    getIndividualPerformance: (userId: number, period: number) =>
        `/authenticated/crm/reports/individual-performance/${userId}?period=${period}`,
    getManagerWisePerformance: (period: number) => `/authenticated/crm/reports/manager-wise-performance?period=${period}`,
    getRoomNightAnalysis: (date: { startDate: string; endDate: string }, userId?: string | number) =>
        `/authenticated/crm/reports/room-night-analysis?startDate=${date.startDate}&endDate=${date.endDate}${
            userId ? `&userId=${userId}` : ''
        }`,

    getActualRevenueByBookingId: (id: any) => `/authenticated/booking-items/${id}/actualization`,
    previewActualization: (id: any) => `/authenticated/booking-items/${id}/actualization/preview`,
    postBill: (id: any) => `/authenticated/booking-items/${id}/post-bill`,
    voidBill: (id: any) => `/authenticated/booking-items/${id}/void-bill`,
    validateEInvoice: (id: any) => `/authenticated/booking-items/${id}/validate-e-invoice`,
    generateIrn: (id: any) => `/authenticated/booking-items/${id}/generate-irn`,
    downloadEInvoicePdf: (id: any) => `/authenticated/booking-items/${id}/e-invoice-pdf`,
    cancelIrn: (id: any) => `/authenticated/booking-items/${id}/cancel-irn`,

    fetchReservations: (id: any) => `/authenticated/room-reservations?roomNo=${id}`,
    downloadActualizationPDF: (id: any, billViewType?: string, eventDate?: string, format?: string) => {
        const params = new URLSearchParams();
        if (billViewType) {
            params.set('billViewType', billViewType);
        }
        if (eventDate) {
            params.set('eventDate', eventDate);
        }
        if (format) {
            params.set('format', format);
        }
        const query = params.toString();
        return `/authenticated/booking-items/${id}/actualization/pdf${query ? `?${query}` : ''}`;
    },
    sendThankYouEmailAfterActualization: (id: any) => `/authenticated/booking-items/${id}/actualization-email`,
    getPaymentMethods: (id: any) => `/authenticated/line-items/${id}/payment-methods`,
    getPaginatedPaymentMethods: `/authenticated/payment-methods/page`,
    syncPaymentMethods: `/authenticated/hotelogix/payment-methods`,
    getPaymentMethodsById: (id: number) => `/authenticated/payment-methods/${id}`,

    getPaginatedAddOnCategories: `/authenticated/add-on-categories/page`,
    syncAddOnCategories: `/authenticated/hotelogix/add-on-categories`,
    getAddOnCategoriesById: (id: number) => `/authenticated/add-on-categories/${id}`,
    getAddOnCategoriesDropdown: '/authenticated/add-on-categories/dropdowns',
    addAddOnCategories: '/authenticated/add-on-categories',

    getPaymentDetailsForBooking: (id: any) => `/authenticated/bookings/${id}/payments`,
    getLineItemPaymentHistory: (id: number | string) => `/authenticated/booking-items/${id}/payment-history`,
    addSettlementEntry: (id: any) => `/authenticated/bookings/${id}/settlement-entries`,
    getSettlementAllocationContext: (bookingId: any, entryId: any) =>
        `/authenticated/bookings/${bookingId}/settlement-entries/${entryId}/allocation-context`,
    settleSettlementEntry: (bookingId: any, entryId: any) =>
        `/authenticated/bookings/${bookingId}/settlement-entries/${entryId}/settle`,
    cancelSettlementEntry: (bookingId: any, entryId: any) =>
        `/authenticated/bookings/${bookingId}/settlement-entries/${entryId}/cancel`,
    reverseSettlementReceipt: (bookingId: any, entryId: any, receiptId: any) =>
        `/authenticated/bookings/${bookingId}/settlement-entries/${entryId}/receipts/${receiptId}/reverse`,

    bookingLogs: (id: any) => `/authenticated/booking-items/${id}/logs`,

    previewMailTemplate: (id: any, lang: any) => `/authenticated/mail-template/${id}/preview/${lang}`,
    industryType: '/authenticated/industry-types/page',
    get_edit_delete_industryTypeById: (id: number) => `/authenticated/industry-types/${id}`,
    addIndustryType: '/authenticated/industry-types',
    getSplitRevenueById: (id: any) => `/authenticated/bookings/${id}/split-actual-revenue`,
    getSalutations: `/authenticated/contact-titles`,
    getMonths: `/authenticated/months`,
    salesCallComments: (id: any) => `/authenticated/crm/sales-call/${id}/comments`,
    bookingLineItemComments: (id: any) => `/authenticated/booking-items/${id}/comments`,
    updateBookingAdditionalComments: (bookingId: number | string) =>
        `/authenticated/bookings/${bookingId}/additional-comments`,
    assignTask: (fromUser: any, toUser: any) => `/authenticated/user/${fromUser}/assign-pending-tasks/${toUser}`,
    corporateRoomRates: '/authenticated/crm/corporate-room-rates/check',
    getAddOnsByCategory: (category: number) => `/authenticated/add-ons/${category}/search`,
    updateCorporateRates: (accountId: number) => `/authenticated/crm/companies/${accountId}/corporate-rates`,
    updateCityPotentials: (accountId: number, branchId: number) =>
        `/authenticated/crm/companies/${accountId}/branches/${branchId}/city-potentials`,
    updateBranchInfo: (accountId: number, branchId: number) =>
        `/authenticated/crm/companies/${accountId}/branches-info/${branchId}`,
    addBranchInfo: (accountId: number) => `/authenticated/crm/companies/${accountId}/branches-info`,

    salesManagerTargetPage: (branchId: number) => `/authenticated/crm/branches/${branchId}/sales-manager-target/page`,
    addSalesManagerTarget: '/authenticated/crm/sales-manager-target',
    getSalesManagerTargetById: (id: number) => `/authenticated/crm/sales-manager-target/${id}`,
    getTargetPeriodsDropdown: (periodType?: string) =>
        `/authenticated/crm/target-periods/dropdown${periodType ? `?periodType=${periodType}` : ''}`,
    getBranchWiseManagersDropdown: (branchId: number) => `/authenticated/crm/branches/${branchId}/managers/dropdown`,
    getKycDocumentTypes: '/authenticated/kyc/document-types',
    getPartOfDays: '/authenticated/part-of-days',
    partOfDayList: (orgId: number | string, isParent: boolean) =>
        `/authenticated/organizations/${orgId}/part-of-day/page?isParent=${isParent}`,
    partOfDayCreate: (orgId: number | string, isParent: boolean) =>
        `/authenticated/organizations/${orgId}/part-of-day?isParent=${isParent}`,
    partOfDayUpdate: (orgId: number | string, id: number | string, isParent: boolean) =>
        `/authenticated/organizations/${orgId}/part-of-day/${id}?isParent=${isParent}`,
    partOfDayById: (id: number | string, orgId: number | string, isParent: boolean) =>
        `/authenticated/part-of-day/${id}?orgId=${orgId}&isParent=${isParent}`,
    partOfDayDelete: (id: number | string, orgId: number | string, isParent: boolean) =>
        `/authenticated/part-of-day/${id}?orgId=${orgId}&isParent=${isParent}`,

    // IDS Configurations URLs
    eventMappings: '/authenticated/ids/event-mappings/page',
    addEventMapping: '/authenticated/ids/event-mappings',
    getEventMappingById: (id: number) => `/authenticated/ids/event-mappings/${id}`,
    editEventMapping: (id: number) => `/authenticated/ids/event-mappings/${id}`,
    deleteEventMapping: (id: number) => `/authenticated/ids/event-mappings/${id}`,
    importEventMappings: '/authenticated/ids/import-ids-configurations',
    downloadEventMappingsTemplate: '/authenticated/ids/import-ids-configurations/template',

    venueMappings: '/authenticated/ids/venue-mappings/page',
    addVenueMapping: '/authenticated/ids/venue-mappings',
    getVenueMappingById: (id: number) => `/authenticated/ids/venue-mappings/${id}`,
    editVenueMapping: (id: number) => `/authenticated/ids/venue-mappings/${id}`,
    deleteVenueMapping: (id: number) => `/authenticated/ids/venue-mappings/${id}`,
    importVenueMappings: '/authenticated/ids/import-ids-configurations',
    downloadVenueMappingsTemplate: '/authenticated/ids/import-ids-configurations/template',

    layoutMappings: '/authenticated/ids/layout-mappings/page',
    addLayoutMapping: '/authenticated/ids/layout-mappings',
    getLayoutMappingById: (id: number) => `/authenticated/ids/layout-mappings/${id}`,
    editLayoutMapping: (id: number) => `/authenticated/ids/layout-mappings/${id}`,
    deleteLayoutMapping: (id: number) => `/authenticated/ids/layout-mappings/${id}`,
    importLayoutMappings: '/authenticated/ids/import-ids-configurations',
    downloadLayoutMappingsTemplate: '/authenticated/ids/import-ids-configurations/template',

    statusMappings: '/authenticated/ids/status-mappings/page',
    addStatusMapping: '/authenticated/ids/status-mappings',
    getStatusMappingById: (id: number) => `/authenticated/ids/status-mappings/${id}`,
    editStatusMapping: (id: number) => `/authenticated/ids/status-mappings/${id}`,
    deleteStatusMapping: (id: number) => `/authenticated/ids/status-mappings/${id}`,
    importStatusMappings: '/authenticated/ids/import-ids-configurations',
    downloadStatusMappingsTemplate: '/authenticated/ids/import-ids-configurations/template',

    // Combined IDS Mappings API
    getAllIdsMappings: '/authenticated/ids/mappings',
    fetchMediatorLogs: (target: string) => `/authenticated/fetch-logs/${encodeURIComponent(target)}`,
    ycsRooms: '/authenticated/ycs/rooms',
    ycsAddOns: '/authenticated/ycs/add-ons',
    ycsAddOnCategories: '/authenticated/ycs/add-on-categories',
    ycsPaymentTypes: '/authenticated/ycs/payment-types',
    ycsTaxCodes: '/authenticated/ycs/tax-codes',
    ycsSyncAddOnCategories: '/authenticated/ycs/sync/add-on-categories',
    ycsSyncAddOns: '/authenticated/ycs/sync/add-ons',
    ycsSyncPaymentMethods: '/authenticated/ycs/sync/payment-methods',
    cancelBookedRoom: (bookedRoomId: number | string) => `/authenticated/booked-rooms/${bookedRoomId}`,
    exportManagersPerformance: (period: number) => `/authenticated/crm/managers-performance/export?period=${period}`,
    revenueSnapshots: '/admin/revenue-snapshots',
    dimensionPerformanceByMonth: '/admin/reports/dimension-performance-by-month',
    dimensionPerformanceCellDetail: '/admin/reports/dimension-performance-cell-detail',
    demandCalendar: '/admin/reports/demand-calendar',
    demandCalendarDayEvents: '/admin/reports/demand-calendar/day-events',
    demandCalendarExport: '/admin/reports/demand-calendar/export',
    exportRevenueSnapshots: '/admin/revenue-snapshots/export',
    revenueOwners: (branchId: number | null = null) =>
        branchId !== null ? `/authenticated/revenue-owners?branchId=${branchId}` : `/authenticated/revenue-owners`,
    reportsExport: (type: string) => `/admin/reports/export?reportType=${type}`,
    consolidatedReportsExport: (type: string) => `/admin/consolidated-reports/export?reportType=${type}`,
    exportCoverReport: '/admin/cover-report/export',

    cancelBookingDropdown: '/authenticated/cancel-booking/dropdown',
};
